import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=18686cfd&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18686cfd')) {
      api.createRecord('18686cfd', component.options)
    } else {
      api.reload('18686cfd', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=18686cfd&", function () {
      api.rerender('18686cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor.vue"
export default component.exports